/**
 * Accessible accordion behavior for key milestones sections.
 *
 * Expected markup:
 * - .key-milestones-section__item
 * - .key-milestones-section__trigger
 * - .key-milestones-section__panel
 */
function initKeyMilestones() {
  const sections = document.querySelectorAll('.key-milestones-section');

  sections.forEach((section, sectionIndex) => {
    if (section.dataset.milestonesInitialized === 'true') return;
    section.dataset.milestonesInitialized = 'true';

    const items = [...section.querySelectorAll('.key-milestones-section__item')];

    items.forEach((item, itemIndex) => {
      const trigger = item.querySelector('.key-milestones-section__trigger');
      const panel = item.querySelector('.key-milestones-section__panel');

      if (!trigger || !panel) return;

      const panelId = panel.id || `key-milestones-panel-${sectionIndex}-${itemIndex}`;
      const triggerId = trigger.id || `key-milestones-trigger-${sectionIndex}-${itemIndex}`;
      const isOpen = item.classList.contains('is-open') || trigger.getAttribute('aria-expanded') === 'true';

      panel.id = panelId;
      trigger.id = triggerId;
      trigger.setAttribute('aria-controls', panelId);
      trigger.setAttribute('aria-expanded', String(isOpen));
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', triggerId);
      panel.hidden = !isOpen;

      const setOpenState = (targetItem, nextState) => {
        const targetTrigger = targetItem.querySelector('.key-milestones-section__trigger');
        const targetPanel = targetItem.querySelector('.key-milestones-section__panel');

        if (!targetTrigger || !targetPanel) return;

        targetItem.classList.toggle('is-open', nextState);
        targetTrigger.setAttribute('aria-expanded', String(nextState));

        if (nextState) {
          targetPanel.hidden = false;
          return;
        }

        targetPanel.addEventListener('transitionend', () => {
          if (!targetItem.classList.contains('is-open')) {
            targetPanel.hidden = true;
          }
        }, { once: true });
      };

      trigger.addEventListener('click', () => {
        const nextState = trigger.getAttribute('aria-expanded') !== 'true';

        items.forEach(currentItem => {
          if (currentItem !== item) {
            setOpenState(currentItem, false);
          }
        });

        setOpenState(item, nextState);
      });
    });
  });
}

export { initKeyMilestones };
